import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';
import { ScheduleService } from 'src/app/service/schedule.service';
import { DatePipe } from '@angular/common';
// Excel sheet export
import { Cell, Workbook } from 'exceljs';
import * as XLSX from 'xlsx';


declare var $: any;
@Component({
  selector: 'app-schedule-details-preview',
  templateUrl: './schedule-details-preview.component.html',
  styleUrls: ['./schedule-details-preview.component.scss']
})
export class ScheduleDetailsPreviewComponent implements OnInit {
  showLoader: boolean = false;
  scheduleSetupId: any;
  yearid: any;
  semesterid: any;
  gradeid: any;
  ScheduleHeader: any;
  ScheduleData: any;
  table: any;
  orgId: any;
  constructor(
    private toastrService: ToastrService
    , public globals: Globals, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router
    , public translate: TranslateService
    , public scheduleService: ScheduleService
    , private datePipe: DatePipe
  ) {

  }

  ngOnInit(): void {
    this.showLoader = true;
    this.orgId = this.globals.currentUserInfo.orgid;
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.scheduleSetupId = params['scheduleId'] || "";
        this.yearid = params['yearid'] || "";
        this.semesterid = params['semesterid'] || "";
        this.gradeid = params['gradeid'] || "";

        if (this.scheduleSetupId != "" && this.yearid != "" && this.semesterid != "" && this.gradeid != "") {
          this.preViewAction();

          this.showLoader = false;

        } else {
          this.toastrService.warning(this.translate.instant('CAN_NOT_GET_SCHEDULE'));
          this.router.navigate(['/schedule/schedule-setup']);
          this.showLoader = false;
        }
      });
  }
  getKeyByValue(object: any, value: any) {
    return Object.keys(object).find(key => object[key] === value);
  }
  preViewAction() {
    let username = this.globals.currentUserInfo.username;
    let reportId = 300;
    let lang = this.globals.lang;
    this.scheduleService.scheduleDetailsPreviewAction(this.orgId, this.scheduleSetupId, lang, username).subscribe(
      data => {
        this.scheduleService.getScheduleDetailsPreview(username, reportId).subscribe(
          data => {
            // console.log(data);
            if (data.length > 0) {
              data.shift();
              var indexString = this.getKeyByValue(data[1], "<LAST COLUMN>")?.replace("col", "");
              let maxColumn = 0;
              if (indexString) {
                maxColumn = parseInt(indexString);
              }

              let newData = data.map((element: any) => {
                let row: any = {};
                row.rowdesc = element.rowdesc;
                let colspan = 1;
                row.rowdesc = {
                  data: element.rowdesc,
                  colspan: colspan
                };
                let previousCellData = "##start";
                let dataIndexName = "";
                for (let i = 1; i < maxColumn; i++) {
                  let indexName = 'col';
                  if (i <= 9) {
                    indexName += "0" + i;
                    // row['col0'+i] =
                  } else {
                    indexName += i;
                    // row['col'+i] =
                  }
                  // row[indexName] = element[indexName];
                  if (previousCellData == element[indexName] && previousCellData != "##start") {
                    // row[indexName] = {
                    //   data: "##merge",
                    //   colspan: 0
                    // };
                    // Update  colspan for main column data
                    row[dataIndexName].colspan = row[dataIndexName].colspan + 1;
                  } else {
                    row[indexName] = {
                      data: element[indexName],
                      colspan: colspan
                    };
                    // Set previous data
                    previousCellData = element[indexName];
                    // Update to current index name
                    dataIndexName = indexName;
                  }

                }
                // console.log(row);
                return row;
              });
              //header
              this.ScheduleHeader = newData[0];
              this.ScheduleHeader = Object.values(this.ScheduleHeader);
              //data
              this.ScheduleData = newData.map((element: any) => {
                return Object.values(element);
              });
              this.ScheduleData.shift();
            } else {
              this.toastrService.error(this.translate.instant('NOT_FOUND'));
            }

          },
          error => {
            //this.showLoader = false;
            this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
          }
        );
      },
      error => {
        //this.showLoader = false;
        this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
      }
    );

  }

  generateExcel() {
    var wb = XLSX.utils.table_to_book(document.getElementById('datatable'));
    XLSX.writeFile(wb, 'schedule_details_preview.xlsx');
    return false;
  }

}

